export default __webpack_public_path__ + "static/media/home_background.dd21af7d.jpeg";